module.exports = __webpack_public_path__ + "static/media/Rankin-Portrait-Photography.210f0554.jpg";